import './veelgestelde-vragen.scss';

const initFaqItem = ( item ) => {
	const button = item.querySelector( '.b-veelgesteldeVragen__question' );
	const answer = item.querySelector( '.b-veelgesteldeVragen__answer' );

	if ( ! ( button instanceof HTMLButtonElement ) || ! answer ) {
		return;
	}

	const setState = ( isOpen ) => {
		button.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		answer.toggleAttribute( 'hidden', ! isOpen );
		answer.setAttribute( 'aria-hidden', isOpen ? 'false' : 'true' );
	};

	setState( ! answer.hasAttribute( 'hidden' ) );

	button.addEventListener( 'click', () => {
		setState( answer.hasAttribute( 'hidden' ) );
	} );
};

document.querySelectorAll( '.b-veelgesteldeVragen__item' ).forEach( initFaqItem );
